// D1 `datetime('now')` values look like "2026-10-08 13:46:52": UTC, but with no
// zone marker. `new Date()` reads that form as LOCAL time, which shows every such
// timestamp hours off. Parse server timestamps through here instead.
const HAS_ZONE = /(?:Z|[+-]\d{2}(?::?\d{2})?)$/i;

export const parseServerTime = (value: string): Date => {
  const text = value.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return new Date(`${text}T00:00:00Z`);
  const iso = text.includes("T") ? text : text.replace(" ", "T");
  return new Date(HAS_ZONE.test(iso) ? iso : `${iso}Z`);
};

export const formatServerDateTime = (value: string): string => {
  const date = parseServerTime(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
};

export const relativeTimeFrom = (iso: string | null) => {
  if (!iso) return null;
  const then = parseServerTime(iso).getTime();
  if (Number.isNaN(then)) return null;
  const minutes = Math.round((Date.now() - then) / 60000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  return `${days}d ago`;
};
